import { userAxios } from "../index";

/**
 * Obtiene el listado paginado de administradores vinculados a agentes.
 */
const getAdminUsers = async (params) =>
  userAxios
    .get("/admin-agent-user", { params })
    .then((response) => response.data);

/**
 * Obtiene la información detallada de un administrador específico
 * incluyendo los agentes asociados.
 */
const getAdminUserDetail = async (adminId) =>
  userAxios
    .get(`/admin-agent-user/${adminId}`)
    .then((response) => response.data);

/**
 * Obtiene todos los agentes, sin filtrar por administrador.
 */
const getAllAgents = async () =>
  userAxios.get("/users/by-agent").then((response) => response.data);

/**
 * Obtiene los agentes asociados a un administrador específico.
 */
const getAgentsByAdmin = async (adminId) =>
  userAxios
    .get(`/get-agent-by-admin/${adminId}`)
    .then((response) => response.data);

/**
 * Recupera la información agregada del dashboard de administradores
 * filtrada por fechas y administrador seleccionado.
 */
const getDashboardData = async (payload) =>
  userAxios
    .post("/agents/dashboard-data", payload)
    .then((response) => response.data);

export default {
  getAdminUsers,
  getAdminUserDetail,
  getAllAgents,
  getAgentsByAdmin,
  getDashboardData,
};

